import React from "react";
import HomepageMain from "./components/Layout/HomepageMain";

const HomePage: React.FC = () => {
  return (
    <div>
      <HomepageMain />
    </div>
  );
};

export default HomePage;
